import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject } from '@angular/core';
import { takeUntilDestroyed, toObservable, toSignal } from '@angular/core/rxjs-interop';
import { environment } from '@environments';
import { COMPANY_SETTINGS_ENDPOINT } from '@models/common.models';
import { CompanySettings } from '@models/webapi/user-profile';
import { CompanyContextService } from '@services/company-context/company-context.service';
import { map, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompanySettingsService {
  #companyContextService = inject(CompanyContextService);
  #http = inject(HttpClient);

  #companySettingsRequest$ = this.#http.get<CompanySettings>(
    `${environment.apiConfig.baseUrl}${COMPANY_SETTINGS_ENDPOINT}`
  );

  #companySettings$ = toObservable(this.#companyContextService.currentCompany).pipe(
    switchMap(() => this.#companySettingsRequest$),
    map(settings => CompanySettings.from(settings)),
    takeUntilDestroyed()
  );

  #companySettings = toSignal(this.#companySettings$);
  public readonly adCvdAnalysisEnabled = computed(() => this.#companySettings()?.adCvdAnalysis ?? false);
  public readonly pgaAnalysisEnabled = computed(() => this.#companySettings()?.pgaAnalysis ?? false);
  public readonly portalUnicoAnalysisEnabled = computed(
    () => this.#companySettings()?.exportToPortalUnicoJson ?? false
  );
  public readonly exportToThomsonReutersEnabled = computed(
    () => this.#companySettings()?.exportToThomsonReutersJson ?? false
  );
  public readonly endUseEnabled = computed(() => this.#companySettings()?.endUse ?? false);
  public readonly primaryService = computed(() => this.#companySettings()?.primaryService);
  public readonly requestCategory = computed(() => this.#companySettings()?.requestCategory ?? false);
  public readonly specialCustomsCodesEnabled = computed(() => this.#companySettings()?.specialCustomsCode ?? false);
  public readonly canadianBrokerDataEnabled = computed(() => this.#companySettings()?.canadianBrokerData ?? false);
}
